import { IndividualData } from "../individuals/individual-data";
import { SignatureStatus } from "./signature-status.enum";

export class Signature {
    id?: string;
    signatoryId?: string;
    signatory: IndividualData;
    email: string;
    phone: string;
    role: string;
    groupName: string;
    groupSubtitle: string;
    groupId: number;
    status: SignatureStatus;
    isWitnessed: boolean;
    isDated: boolean;
    isNameChangable: boolean;
    fileNames: string[];
    emailSendId: string;
    signedOn: string | null;

    constructor(data: Partial<Signature>) {
        this.id = data.id ?? '';
        this.signatoryId = data.signatoryId ?? '';
        this.signatory = data.signatory ? new IndividualData(data.signatory) : new IndividualData();
        this.email = data.email ?? '';
        this.phone = data.phone ?? '';
        this.role = data.role ?? '';
        this.groupName = data.groupName ?? '';
        this.groupSubtitle = data.groupSubtitle ?? '';
        this.groupId = data.groupId ?? 0;
        this.status = data.status ?? 0;
        this.isWitnessed = data.isWitnessed ?? false;
        this.isDated = data.isDated ?? true;
        this.isNameChangable = data.isNameChangable ?? false;
        this.fileNames = data.fileNames ?? [];
        this.emailSendId = data.emailSendId ?? '';
        this.signedOn = data.signedOn ?? null;
    }
}
